module.exports = __webpack_public_path__ + "img/bell.57f9ee7.svg";